import { Base } from "ui/Scripts/source/framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { ILogListItems, LogListItems } from "./logListItems";

export interface ILogPage {
    companies: ICompanyMenuItem[];
    list: ILogListItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class LogPage implements ILogPage {
    companies: CompanyMenuItem[];
    list: LogListItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: ILogPage);
    constructor(obj?: any) {
        this.list = new LogListItems(obj && obj.list || null);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
    }
}